import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useSelectAllScenarioClassConversions = () => {
  const { mutate: selectAllClassConversions, isPending } = useAppMutation(
    [QueryKey.CREATE_SCENARIO_CLASS_CONVERSION],
    {
      mutationFn: ({ scenarioId, shareClassId }: { scenarioId: string; shareClassId?: string }) =>
        ApiService.post({
          endpoint: BackendRoute.SCENARIOS,
          routePath: shareClassId
            ? [scenarioId, 'class-conversion-tasks', 'convert-all', shareClassId]
            : [scenarioId, 'class-conversion-tasks', 'convert-all'],
        }),
    },
  );
  return { selectAllClassConversions, isPending };
};
